import { WorkCardSkeleton } from '@diana/core';
import { Grid } from '@mui/material';

export function LoadingCards({ num = 25, height }: { num?: number; height?: number | string }) {
  return (
    <Grid container rowSpacing={2} spacing={2}>
      <WorkCardSkeleton num={num} height={height} />
    </Grid>
  );
}
